import React from "react";
import { Address, capitalizeFirstLetter } from "../../../core";

const AddressDetalsView = ({ addressDetails }: { addressDetails: Address }) => {
  return (
    <div className="font-sm   px-0">
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"Address Type"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">
            {capitalizeFirstLetter(addressDetails?.addressType || "")}
          </div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"Address "}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.address || ""}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"Country"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.country || ""}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"State"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.state || ""}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"District"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.district || ""}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"City"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.city || ""}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"Zip Code"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.postalCode || ""}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">
          {"Contact Status"}
        </div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.contactStatus || ""}</div>
        </div>
      </div>
      {/* <div className="d-flex flex-wrap px-4 py-1 align-items-center flex-wrap">
        <div className="col pl-0 pr-2 contact-label  font-xs text-gray-500 text-right ">{"Remarks"}</div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
          <div className="font-sm font-weight-semibold">{addressDetails?.remarks || ""}</div>
        </div>
      </div> */}
    </div>
  );
};

export default AddressDetalsView;
